import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class InitiativesPopoverProgressNewComponent extends Component {
  @tracked isOpen = false;

  @action
  setIsOpen(val) {
    this.isOpen = val;
  }
}
